module.exports = __webpack_public_path__ + "img/courier-tsl.52e47d23.svg";